import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
import axios from 'src/app/Service/axios';
declare let $: any;

@Component({

  selector: 'app-taxi-monthly-report',

  templateUrl: './taxi-monthly-report.component.html',

  styleUrls: ['./taxi-monthly-report.component.css']

})

export class TaxiMonthlyReportComponent implements OnInit {

  lst_Lines: any = [];

  lst_Report: any = [];

  lst_Search: any = [];

  fKmTotal: number = 0;

  fADT: number = 0;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(moment().subtract(30, 'day').format('jYYYY/jMM/jDD'), Validators.required),

    strEDate: new FormControl(moment().subtract(1, 'day').format('jYYYY/jMM/jDD'), Validators.required),

    iBusLine: new FormControl(-1),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  ngOnInit(): void {

    this.get_Lines();

  }

  async get_Lines() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Bus_Line_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Lines = res;

  }

  async search_Report() {

    if (this.mdl_Search.invalid) return this._tooltip.showError('تاریخ شروع و پایان را وارد کنید')

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Taxi_FleetPerformanceReport`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Report = res;

    this.lst_Search = res;

    this.fKmTotal = 0;

    this.fADT = 0;

    this.lst_Report.forEach((el: any) => {

      this.fKmTotal += el.fKmTotal;

      this.fADT += el.fADT;

    })

    this.fADT = this.fADT / this.lst_Report.length;

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  filter_list(val: any) {

    this.lst_Report = this.lst_Search.filter((el: any) => {

      return el?.strBusLineName?.toString().startsWith(val.value) ||

        el.strFullName?.toString().startsWith(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Report = this.lst_Search;

    }

  }

  exportExcel(id: any): void {

    let element = document.getElementById(`${id}`);

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, 'گزارش عملکرد ماهیانه.xlsx');

  }

  sortfKmTotal() {

    if (this.lst_Report.length < 2) return;

    const isAsc = Number(this.lst_Report[0].fKmTotal) <= Number(this.lst_Report[this.lst_Report.length - 1].fKmTotal);

    this.lst_Report.sort((a: any, b: any) => {

      const aVal = Number(a.fKmTotal);

      const bVal = Number(b.fKmTotal);

      return isAsc ? bVal - aVal : aVal - bVal;

    });

  }

  sortfADT() {

    if (this.lst_Report.length < 2) return;

    const isAsc = Number(this.lst_Report[0].fADT) <= Number(this.lst_Report[this.lst_Report.length - 1].fADT);

    this.lst_Report.sort((a: any, b: any) => {

      const aVal = Number(a.fADT);

      const bVal = Number(b.fADT);

      return isAsc ? bVal - aVal : aVal - bVal;

    });

  }

  openDetails(item) {

    const start = this.mdl_Search.get('strSDate')?.value;

    const end = this.mdl_Search.get('strEDate')?.value;

    const params = new URLSearchParams({

      start,

      end
      
    })

    window.open(`/vehicle-management/taxi/monthly-report/${item.strUnitID}?${params}`, '_blank');

  }

}
